import React from "react";
import FetchApi from "../../../../customhooks/functionFetchApi"

const FetchApis =new FetchApi();

export function getcolor6(tecId, NewtecId){
        FetchApis.FethcGet(`/color/getInk6colorbytecbid/${tecId}`).then(res=>{
            if(res){
                var dataall=res.data.data;
                for (let index = 0; index < dataall.length; index++) {
                    const colorlist = dataall[index];
                        createcolor6(colorlist,NewtecId);
                }   
            }
        })
}

function createcolor6(colorlist,NewtecId){
        var objectdata={
         tecbid:NewtecId,
            colorshqde_unit1:colorlist.colorshqde_unit1,
            Idcolor_unit1:colorlist.Idcolor_unit1,
            fmcode_unit1:colorlist.fmcode_unit1,
            thicknes_unit1:colorlist.thicknes_unit1,
            density_unit1:colorlist.density_unit1,
            temp_unit1:colorlist.temp_unit1,
            uvlamp_unit1:colorlist.uvlamp_unit1,
            speed_unit1:colorlist.speed_unit1,
                colorshqde_unit2:colorlist.colorshqde_unit2, 
                Idcolor_unit2:colorlist.Idcolor_unit2,
                fmcode_unit2:colorlist.fmcode_unit2,
                thicknes_unit2:colorlist.thicknes_unit2,
                density_unit2:colorlist.density_unit2,
                temp_unit2:colorlist.temp_unit2,
                uvlamp_unit2:colorlist.uvlamp_unit2, 
                speed_unit2:colorlist.speed_unit2,
                pt_type:colorlist.pt_type
    }
    FetchApis.FethcPost(`/color/createInk6color`,objectdata).then(res=>{

    })
}